<template lang="pug">
  observer.landing.relative.h-screen(:style="{height: `${winH}px`}", :threshold="0.05", @visible="$emit('visible')", @hidden="$emit('hidden')")
    //- video
    template(v-if="format === 'video' && video")
      hero-video(v-if="video", :video="video")
    //- image
    template(v-else-if="format === 'image'")
      transition-group(name="fade")
        //- portrait img
        resp-img.absolute.overlay(key="0", v-if="img('portrait') && winIs('portrait')", :src="img('portrait').url", :alt="img('portrait').alt", :bg="true", bgClass="bg-top bg-cover bg-no-repeat")
        //- landscape img
        resp-img.absolute.overlay(key="1", v-else-if="img('landscape')", :src="img('landscape').url", :alt="img('landscape').alt", :bg="true", bgClass="bg-top bg-cover bg-no-repeat", :useHeight="winIs('portrait')")
    //- kannswiss logo
    //- .absolute.bottom-0.right-0.px-20.pb-24
      img.block(src="@/assets/kannaswiss_logo_white.png", style="height:1.2rem")
</template>

<script>
import { mapGetters } from 'vuex'
import HeroVideo from '@/components/HeroVideo'
import RespImg from '@/components/RespImg'
import Observer from '@/components/IntersectionObserver'
import get from 'lodash/get'
export default {
  name: 'Landing',
  data () {
    return {
      winH: window.innerHeight,
      loading: true
    }
  },
  computed: {
    ...mapGetters(['winIs']),
    doc () {
      return this.$store.state.pages['home']
    },
    format () {
      return this.doc && this.doc.acf.landing_format
    },
    video () {
      const key = this.winIs('portrait') ? 'portrait' : 'landscape'
      // external / cloudinary ?
      const external = get(this.doc, 'acf.landscape_video_external_url')
      if (external) {
        return { url: get(this.doc, `acf.${key}_video_external_url`) }
      }
      // internal / wp (default)
      return get(this.doc, `acf.landing_video_${key}`)
    }
  },
  methods: {
    img (key) {
      return this.doc && this.doc.acf[`landing_image_${key}`]
    },
    onResize () {
      this.winH = window.innerHeight
    }
  },
  mounted () {
    this.$store.state.bus.$on('newWindowWidth', this.onResize)
  },
  destroyed () {
    this.$store.state.bus.$off('newWindowWidth', this.onResize)
  },
  components: { RespImg, HeroVideo, Observer }
}
</script>

<style>
</style>
